/** Гранулярные подсказки по адресу. Параметр `from_bound.value` и `to_bound.value` */
export const EAddressBounds = Object.freeze({
    /** Страна */
    COUNTRY: 'country',
    /** Регион */
    REGION: 'region',
    /** Район */
    AREA: 'area',
    /** Город */
    CITY: 'city',
    /** Населенный пункт */
    SETTLEMENT: 'settlement',
    /** Улица */
    STREET: 'street',
    /** Дом */
    HOUSE: 'house',
    /** Квартира (21.12+)  Квартира поддерживается только как правая граница. То есть можно указать границы house-flat или street-flat, но не просто flat. */
    FLAT: 'flat',
})
